<template>
  <v-icon
  :color="color"
  :size="size">
    mdi-{{src}}
  </v-icon>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      defualt: () => {
        return 30
      }
    },
    color: {
      type: String,
      defualt: () => {
        return 'black'
      }
    },
    src: {
      type: String,
      required: true
    },
  }
}
</script>
<style>

</style>